export const QUOTES_SLIDER = [
    {
        title: 'Godność',
        quote: '„Szlachetna Paczka pozwala ludziom w potrzebie nie tylko dostać to czego potrzebują, ale poczuć się godnie, tak jak inni, poczuć się częścią społeczeństwa."'
    },
    {
        title: 'Refleksja',
        quote: '„Dla darczyńców Paczka jest lekcją życia, nauką pokory i doceniania małych rzeczy.”'
    },
    {
        title: 'Radość',
        quote: '„Nie spodziewałam się, że tak wielką radość może przynieść pomoc innym. Czułam się jak członek rodziny, którą wybrałam. To było cudowne doświadczenie.”'
    },
    {
        title: 'Relacja',
        quote: '„Paczka jest sposobem na mądrą pomoc potrzebującym, ale też momentem, w którym zbliżam się z przyjaciółmi i znajomymi - to daje nam ogromną satysfakcję.”'
    },
    {
        title: 'Tradycja',
        quote: '„Paczka teraz już dla mnie tradycją i corocznym spełnieniem ważnej życiowej wartości jaką jest pomaganie innym.”'
    }
];
